<template>
    <span>
        ( {{ $t('base.establishmentTimeZone') + ' ' + showTimeZoneCode }} )
    </span>
</template>

<script>
import { timezones } from '@/mixins/timezones';
import { mapGetters } from 'vuex';
import { EstablishmentSetting } from '../../enums';

export default {
    name: 'show-timezone-code',
    props: {
        isVirtualService: { type: Boolean, required: false, default: false },
    },
    data() {
        return{
            Timezones: {
                'EDT': 'easternTime',
                'EST': 'easternTime',
                'ADT': 'atlanticTime',
                'AST': 'atlanticTime'
            }
        };
    },
    mixins: [timezones],
    computed: {
        ...mapGetters({
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
        }),
        showTimeZoneCode() {
            if (this.isVirtualService) {
                return this.showNavigatorTimeZoneCode;
            }
            return this.showEstablishmentTimeZoneCode;
        },

        showEstablishmentTimeZoneCode() {
            return this.getTimeZoneCode(this.fetchEstablishmentSetting('DEFAULT_TIMEZONE'));
        },

        showNavigatorTimeZoneCode() {
            return this.getTimeZoneCode(Intl.DateTimeFormat().resolvedOptions().timeZone);
        },

        getTimeZone() {
            return this.Timezones[this.showTimeZoneCode];
        }
    },
    methods: {
        fetchEstablishmentSetting(setting) {
            return this.getEstablishmentSettingById(EstablishmentSetting[setting]);
        },
    },
};
</script>
